import { memo, useMemo } from 'react';
import {
  Documentation,
  DocumentationCategory,
  DocumentationFilterInputObject,
  FilterGroupingEnum,
} from 'graphql-common';
import LinkedDocuments, {
  LinkedDocumentsVariant,
} from '@lib/components/LinkedDocuments';
import { APP_URLS } from 'constants/urls';

interface Props {
  item: DocumentationCategory;
}

const getDetailsUrl = (doc: Documentation) =>
  APP_URLS.dashboard.documentation.view.getDynamicPath({
    pathParts: { id: doc.id },
  });

function LinkedDocumentsCell({ item }: Props) {
  const filters = useMemo<DocumentationFilterInputObject[]>(
    () => [
      {
        categoryName: {
          grouping: FilterGroupingEnum.And,
          predicate: { eq: item.name },
        },
      },
    ],
    [item.name],
  );

  if (!item.documentationsCount) return null;

  return (
    <LinkedDocuments
      variant={LinkedDocumentsVariant.LinkList}
      filters={filters}
      getDetailsUrl={getDetailsUrl}
    />
  );
}

export default memo(LinkedDocumentsCell);
